(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fee-experience-nav"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fee-sticky-bars')){
  customElements.define('fee-sticky-bars',class extends HTMLElement{
    connectedCallback(){
      this.announcement=document.querySelector('.shopify-section-group-header-group.announcement-bar-section');
      this.section=this.closest('.shopify-section');
      this.update=()=>{
        const announcementHeight=this.announcement?this.announcement.getBoundingClientRect().height:0;
        const navHeight=this.section.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--fee-announcement-height',announcementHeight+'px');
        document.documentElement.style.setProperty('--fee-bars-height',(announcementHeight+navHeight)+'px');
      };
      this.observer=new ResizeObserver(this.update);
      if(this.announcement)this.observer.observe(this.announcement);
      this.observer.observe(this.section);
      this.update();
    }
    disconnectedCallback(){this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fee-help"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fee-help'))customElements.define('fee-help',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.category='all';const search=this.querySelector('input'),buttons=this.querySelectorAll('[data-filter]'),items=this.querySelectorAll('details'),status=this.querySelector('[data-empty-message]');const update=()=>{const term=search.value.toLocaleLowerCase().trim();let count=0;items.forEach(item=>{item.hidden=!(this.category==='all'||item.dataset.category===this.category)||!item.textContent.toLocaleLowerCase().includes(term);if(!item.hidden)count++;});status.hidden=count>0;status.textContent=count?'':this.dataset.empty;};search.addEventListener('input',update);buttons.forEach(b=>b.addEventListener('click',()=>{this.category=b.dataset.filter;buttons.forEach(x=>x.setAttribute('aria-pressed',String(x===b)));update();}));}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fee-inspiration"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fee-inspiration'))customElements.define('fee-inspiration',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.querySelectorAll('[data-look]').forEach(b=>b.addEventListener('click',()=>{this.querySelectorAll('[data-look]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));this.querySelectorAll('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==b.dataset.look);}));}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fee-match"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fee-match'))customElements.define('fee-match',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.querySelector('form').addEventListener('submit',e=>{e.preventDefault();const d=new FormData(e.target);let mode=d.get('density')==='fine'||d.get('length')==='short'?'consult':d.get('method')==='unsure'?'compare':d.get('method');this.querySelectorAll('[data-advice]').forEach(p=>p.hidden=p.dataset.advice!==mode);this.querySelectorAll('[data-color]').forEach(p=>p.hidden=p.dataset.color!==d.get('color'));this.querySelectorAll('[data-result-link]').forEach(p=>p.hidden=mode==='consult'||(mode!=='compare'&&p.dataset.resultLink!==mode));const result=this.querySelector('[data-result]');result.hidden=false;result.querySelector('h3').focus();const field=document.querySelector('[name="contact[body]"]');const summary=Array.from(e.target.querySelectorAll('select')).map(s=>s.previousElementSibling.textContent+' '+s.selectedOptions[0].textContent).join('\n');if(field&&(!field.value||field.value===field.dataset.feeAutoSummary)){field.value=summary;field.dataset.feeAutoSummary=summary;}this.dispatchEvent(new CustomEvent('fee:match-completed',{bubbles:true,detail:{method:mode,color:d.get('color')}}));});}});
if(!customElements.get('fee-quantity'))customElements.define('fee-quantity',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const input=this.querySelector('input'),out=this.querySelector('[data-quantity-output]');input.addEventListener('input',()=>{const n=Number(input.value);out.textContent=!input.value?out.dataset.empty:!input.validity.valid||!Number.isFinite(n)?out.dataset.invalid:Math.ceil(n/100)+' '+out.dataset.unit;});}});
if(!customElements.get('fee-photos'))customElements.define('fee-photos',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.urls=[];this.files=[];const input=this.querySelector('input'),preview=this.querySelector('.fee-preview-row'),status=this.querySelector('[data-photo-status]');this.clear=()=>{this.urls.forEach(URL.revokeObjectURL);this.urls=[];this.files=[];input.value='';preview.replaceChildren();status.textContent='';};input.addEventListener('change',()=>{const files=Array.from(input.files);this.urls.forEach(URL.revokeObjectURL);this.urls=[];preview.replaceChildren();this.files=[];if(files.length>3||files.some(f=>!['image/jpeg','image/png','image/webp'].includes(f.type)||f.size>10*1024*1024)){input.value='';status.textContent=this.dataset.invalid;return;}this.files=files;files.forEach(f=>{const url=URL.createObjectURL(f);this.urls.push(url);const img=document.createElement('img');img.src=url;img.alt=f.name;preview.append(img);});status.textContent=files.length?this.dataset.selected:'';});this.querySelector('[data-clear]').addEventListener('click',this.clear);}disconnectedCallback(){(this.urls||[]).forEach(URL.revokeObjectURL);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
      this.resizeObserver.observe(this.header);

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.resizeObserver?.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
